// import { useState } from 'react'
// import { Input } from '../../Components/ui/input'
// import { Button } from '../../Components/ui/button'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../Components/ui/tabs'
import UserBasketHoldings from './UserBasketHoldings'
import UserBasketOrderHistory from './UserBasketOrderHistory'
import UserIndividualHoldings from './UserIndividualHoldings'
import UserSips from './UserSIPs'
import UserBasketSIPs from './UserBasketSIPs'
import UserNonFabitsAssets from './UserNonFabitsAssets'
import CreateMandate from './CreateMandate'

const UserHoldings = () => {
  const customerDetails = sessionStorage.getItem('actionPlanUser')
  const pan = JSON.parse(customerDetails)?.data?.panNumber
  const clientCode = JSON.parse(customerDetails)?.data?.uid?.split('-')[0]?.toUpperCase()

  // const [uccId, setUccId] = useState(pan)
  // const [submittedClientCode, setSubmittedClientCode] = useState(clientCode)

  // const handleSubmit = (e) => {
  //   e.preventDefault()
  //   if (uccId.trim()) {
  //     setSubmittedClientCode(uccId.trim().toUpperCase())
  //   }
  // }
  return (
    <div className='w-full h-screen p-2 md:p-4'>
      {/* <form
        onSubmit={handleSubmit}
        className='flex flex-col md:flex-row gap-3 md:gap-x-7 items-stretch md:items-center mb-4 md:mb-6'
      >
        <div className='flex-[2]'>
          <Input
            placeholder='Enter Client Code'
            id='uccId'
            name='uccId'
            value={uccId}
            onChange={(e) => {
              setUccId(e.target.value)
              setSubmittedClientCode('')
            }}
            className='text-sm md:text-base'
          />
        </div>

        <Button
          type='submit'
          className='w-full text-base md:text-lg max-w-full md:max-w-[200px] py-2 md:py-3'
        >
          SUBMIT
        </Button>
      </form> */}

      {clientCode ? (
        <div>
          <h2 className='text-lg md:text-xl font-semibold mb-3 md:mb-4'>
            Holdings for Client Code: {clientCode}
          </h2>
          {/* Tab UI can go here */}
          <div className='w-full max-w-[1128px] pt-6 md:pt-12 mx-auto'>
            <Tabs defaultValue='userBasketHoldings' className='relative mr-auto w-full'>
              <TabsList className='w-full justify-start rounded-none border-b bg-transparent p-0 overflow-x-auto flex-nowrap'>
                <TabsTrigger
                  value='userBasketHoldings'
                  className='relative rounded-none border-b-2 border-b-transparent bg-transparent px-2 md:px-4 pb-2 md:pb-3 pt-2 text-xs md:text-sm font-semibold text-muted-foreground shadow-none transition-none focus-visible:ring-0 data-[state=active]:border-b-primary data-[state=active]:text-foreground data-[state=active]:shadow-none whitespace-nowrap'
                >
                  Basket Holdings
                </TabsTrigger>

                <TabsTrigger
                  value='userIndividualHoldings'
                  className='relative rounded-none border-b-2 border-b-transparent bg-transparent px-2 md:px-4 pb-2 md:pb-3 pt-2 text-xs md:text-sm font-semibold text-muted-foreground shadow-none transition-none focus-visible:ring-0 data-[state=active]:border-b-primary data-[state=active]:text-foreground data-[state=active]:shadow-none whitespace-nowrap'
                >
                  Individual Holdings
                </TabsTrigger>

                <TabsTrigger
                  value='Non Fabits Assets'
                  className='relative rounded-none border-b-2 border-b-transparent bg-transparent px-2 md:px-4 pb-2 md:pb-3 pt-2 text-xs md:text-sm font-semibold text-muted-foreground shadow-none transition-none focus-visible:ring-0 data-[state=active]:border-b-primary data-[state=active]:text-foreground data-[state=active]:shadow-none whitespace-nowrap'
                >
                  Non Fabits Assets
                </TabsTrigger>

                <TabsTrigger
                  value='UserSIPs'
                  className='relative rounded-none border-b-2 border-b-transparent bg-transparent px-2 md:px-4 pb-2 md:pb-3 pt-2 text-xs md:text-sm font-semibold text-muted-foreground shadow-none transition-none focus-visible:ring-0 data-[state=active]:border-b-primary data-[state=active]:text-foreground data-[state=active]:shadow-none whitespace-nowrap'
                >
                  SIPs
                </TabsTrigger>

                <TabsTrigger
                  value='BasketSIPs'
                  className='relative rounded-none border-b-2 border-b-transparent bg-transparent px-2 md:px-4 pb-2 md:pb-3 pt-2 text-xs md:text-sm font-semibold text-muted-foreground shadow-none transition-none focus-visible:ring-0 data-[state=active]:border-b-primary data-[state=active]:text-foreground data-[state=active]:shadow-none whitespace-nowrap'
                >
                  Basket SIPs
                </TabsTrigger>
                <TabsTrigger
                  value='userBasketOrderHistory'
                  className='relative rounded-none border-b-2 border-b-transparent bg-transparent px-2 md:px-4 pb-2 md:pb-3 pt-2 text-xs md:text-sm font-semibold text-muted-foreground shadow-none transition-none focus-visible:ring-0 data-[state=active]:border-b-primary data-[state=active]:text-foreground data-[state=active]:shadow-none whitespace-nowrap'
                >
                  Order History
                </TabsTrigger>

                <TabsTrigger
                  value='CreateMandate'
                  className='relative rounded-none border-b-2 border-b-transparent bg-transparent px-2 md:px-4 pb-2 md:pb-3 pt-2 text-xs md:text-sm font-semibold text-muted-foreground shadow-none transition-none focus-visible:ring-0 data-[state=active]:border-b-primary data-[state=active]:text-foreground data-[state=active]:shadow-none whitespace-nowrap'
                >
                  Create Mandate
                </TabsTrigger>
              </TabsList>

              <TabsContent value='userBasketHoldings'>
                <UserBasketHoldings clientCode={clientCode} />
              </TabsContent>

              <TabsContent value='userIndividualHoldings'>
                <UserIndividualHoldings clientCode={pan} />
              </TabsContent>

              <TabsContent value='Non Fabits Assets'>
                <UserNonFabitsAssets clientCode={pan} />
              </TabsContent>

              <TabsContent value='UserSIPs'>
                <UserSips clientCode={clientCode} />
              </TabsContent>

              <TabsContent value='BasketSIPs'>
                <UserBasketSIPs clientCode={clientCode} />
              </TabsContent>

              <TabsContent value='userBasketOrderHistory'>
                <UserBasketOrderHistory clientCode={clientCode} />
              </TabsContent>

              <TabsContent value='CreateMandate'>
                <CreateMandate clientCode={clientCode} />
              </TabsContent>
            </Tabs>
          </div>
        </div>
      ) : (
        <p className='text-gray-600 text-sm md:text-base'>Enter Client code above to start</p>
      )}
    </div>
  )
}

export default UserHoldings
